import { render, staticRenderFns } from "./WorkflowArchiveQueue.vue?vue&type=template&id=e45b4944&scoped=true&"
import script from "./WorkflowArchiveQueue.vue?vue&type=script&lang=ts&"
export * from "./WorkflowArchiveQueue.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowArchiveQueue.vue?vue&type=style&index=0&id=e45b4944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45b4944",
  null
  
)

export default component.exports